import { render, staticRenderFns } from "./impact-form-prompt-order-modal.vue?vue&type=template&id=6870bb12&scoped=true&"
import script from "./impact-form-prompt-order-modal.vue?vue&type=script&lang=js&"
export * from "./impact-form-prompt-order-modal.vue?vue&type=script&lang=js&"
import style0 from "./impact-form-prompt-order-modal.vue?vue&type=style&index=0&id=6870bb12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6870bb12",
  null
  
)

export default component.exports